<template>
	<div class="system-dairy">
		<div class="view-title">
			<translate>System Logs</translate>
		</div>
		<el-tabs type="card" class="tableTab" :active-name="log.currentTab" @tab-click="onTabClick">
			<!--search input-->
			<div class="add-ssk">
				<div class="pull-right">
					<el-form :inline="true" class="demo-form-inline">
						<el-select v-if="['teamLogs', 'clusterLogs', 'resourceLogs'].includes(log.currentTab)" v-model="search.eventType" :placeholder="attrText.eventType" class="event-search">
							<el-option :label="$gettext('Event Type')" value=""></el-option>
							<el-option v-for="(val, key, index) in selectOptions.event" :label="val.text | translate($gettext)" :value="val.code" :key="index"> </el-option>
						</el-select>
						<el-select v-if="log.currentTab === 'loginLogs'" v-model="search.isAdmin" :placeholder="attrText.userType" class="account-search">
							<el-option :label="attrText.userType" value=""></el-option>
							<el-option :label="attrText.admin" value="1"></el-option>
							<el-option :label="attrText.optAdmin" value="3"></el-option>
							<el-option :label="attrText.auditAdmin" value="2"></el-option>
							<el-option :label="attrText.safeAdmin" value="4"></el-option>
							<el-option :label="attrText.ordinary" value="0"></el-option>
						</el-select>
						<el-select v-if="['teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(log.currentTab)" v-model="search.role" :placeholder="attrText.select" @change="onSelectRole" class="account-search">
							<el-option :label="attrText.select" value=""></el-option>
							<el-option v-for="(item, index) in selectOptions.role" :label="item.text | translate($gettext)" :value="item.val" :key="index"></el-option>
						</el-select>
						<el-input v-if="['teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(log.currentTab)" icon="search" v-model="search.account" :placeholder="log.currentTab === 'loginLogs' ? attrText.inputAccount : attrText.input" class="searchInput" :disabled="log.currentTab === 'loginLogs' ? !search.isDisabled : search.isDisabled"></el-input>
						<el-date-picker v-if="['loginLogs', 'teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(log.currentTab)" v-model="search.startTime" type="date" :placeholder="attrText.startTime" align="right" class="date-picker"></el-date-picker>
						<el-date-picker v-if="['loginLogs', 'teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(log.currentTab)" v-model="search.endTime" type="date" :placeholder="attrText.endTime" align="right" class="date-picker"></el-date-picker>
						<el-button class="btn-class" @click="onSearch">
							<translate>Search</translate>
						</el-button>
						<el-button class="btn-class" type="primary" @click="exportLog">
							<translate>Export</translate>
						</el-button>
					</el-form>
				</div>
			</div>
			<!--login logs-->
			<el-tab-pane :label="attrText.loginLog" name="loginLogs" :disabled="loading">
				<div v-if="log.currentTab === 'loginLogs'">
					<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
						<el-table-column :label="attrText.time">
							<template scope="scope">
								<p>{{ (scope.row.time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.account" prop="account"></el-table-column>
						<el-table-column :label="attrText.accountType">
							<template scope="scope">
								<p v-if="scope.row.admin == 0">{{ attrText.ordinary }}</p>
								<p v-if="scope.row.admin == 1">{{ attrText.admin }}</p>
								<p v-if="scope.row.admin == 2">{{ attrText.auditAdmin }}</p>
								<p v-if="scope.row.admin == 3">{{ attrText.optAdmin }}</p>
								<p v-if="scope.row.admin == 4">{{ attrText.safeAdmin }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.loginIp" prop="ip" width="200"></el-table-column>
						<el-table-column :label="attrText.loginStatus" width="200">
							<template scope="scope">
								<p v-if="scope.row.success" style="color: #88d8a5">成功</p>
								<p v-else style="color: #e47470">失败</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.comment" prop="reason" width="200"></el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			<!-- team logs-->
			<el-tab-pane :label="attrText.teamLog" name="teamLogs" :disabled="loading">
				<div v-if="log.currentTab === 'teamLogs'">
					<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
						<el-table-column :label="attrText.time">
							<template scope="scope">
								<p>{{ (scope.row.time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.account" prop="account"></el-table-column>
						<el-table-column :label="attrText.event" width="200">
							<template scope="scope">
								<p v-if="eventShow">{{ selectOptions.event[scope.row.event].text | translate($gettext) }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.accountEdited">
							<template scope="scope">
								{{ scope.row.user ? scope.row.user : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.groupEdited">
							<template scope="scope">
								{{ scope.row.group ? scope.row.group : '-' }}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			<!-- cluster logs -->
			<el-tab-pane :label="attrText.clusterLog" name="clusterLogs" :disabled="loading">
				<div v-if="log.currentTab === 'clusterLogs'">
					<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
						<el-table-column :label="attrText.time">
							<template scope="scope">
								<p>{{ (scope.row.time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.account" prop="account"></el-table-column>
						<el-table-column :label="attrText.event">
							<template scope="scope" v-if="scope.row.event">
								<p v-if="eventShow && selectOptions.event[scope.row.event]">{{ selectOptions.event[scope.row.event].text | translate($gettext) }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.clusterName">
							<template scope="scope">
								{{ scope.row.net_name ? scope.row.net_name : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.resourceName">
							<template scope="scope">
								{{ scope.row.resource_name ? scope.row.resource_name : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.teamName" width="100">
							<template scope="scope">
								{{ scope.row.shared_company_name ? scope.row.shared_company_name : '-' }}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			<!-- resource logs -->
			<el-tab-pane :label="attrText.workgroupLog" name="resourceLogs" :disabled="loading">
				<div v-if="log.currentTab === 'resourceLogs'">
					<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
						<el-table-column :label="attrText.time">
							<template scope="scope">
								<p>{{ (scope.row.time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.account" prop="account"></el-table-column>
						<el-table-column :label="attrText.event">
							<template scope="scope">
								<p v-if="eventShow && selectOptions.event[scope.row.event]">{{ selectOptions.event[scope.row.event].text | translate($gettext) }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.workgroupName">
							<template scope="scope">
								{{ scope.row.project_name ? scope.row.project_name : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.resourceName">
							<template scope="scope">
								{{ scope.row.resource_name ? scope.row.resource_name : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.accountEdited">
							<template scope="scope">
								{{ scope.row.project_account ? scope.row.project_account : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.groupEdited">
							<template scope="scope">
								{{ scope.row.group ? scope.row.group : '-' }}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			<!-- alarm logs -->
			<!-- <el-tab-pane :label="attrText.alarmLog" name="alarmLogs" :disabled="loading">
				<div v-if="log.currentTab === 'alarmLogs'">
					<el-table v-loading="loading" :data="log.list" style="width: 100%" stripe>
						<el-table-column :label="attrText.operationTime" prop="operation_time" width="200"> </el-table-column>
						<el-table-column :label="attrText.users" prop="account_name" width="80"> </el-table-column>
						<el-table-column :label="attrText.sourceIp" prop="con_ip"> </el-table-column>
						<el-table-column :label="attrText.operationObj" prop="resource_name"> </el-table-column>
						<el-table-column :label="attrText.workGroup" prop="project_name"> </el-table-column>
						<el-table-column :label="attrText.connectType" prop="way"> </el-table-column>
						<el-table-column :label="attrText.eventDesc">
							<template scope="scope">
								<p class="ellipsis-mult">{{ scope.row.command }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.norifyObj">
							<template scope="scope">
								<div v-if="scope.row.notice_accounts">
									<p v-for="i in JSON.parse(scope.row.notice_accounts)" :key="i">{{ i }}</p>
								</div>
							</template>
						</el-table-column>

						<el-table-column :label="attrText.action">
							<template scope="scope">
								<el-button type="text" @click="toShowAlarmDetail(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane> -->

			<!--pagination-->
			<div class="pagination">
				<el-pagination layout="prev, pager, next" :total="log.totalPage" :current-page.sync="log.currentPage" :page-size="10" @current-change="onChangePage" v-if="log.totalPage > 10"></el-pagination>
			</div>
		</el-tabs>
		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="getAlarmLog"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import { SelectOptionsConfig } from '../../config'
import alarmLogDetail from './model/alarm-log-detail.vue'
import { Utils, baseUrl } from '../../config'

export default {
	data() {
		return {
			selectOptions: {},
			loading: true,
			log: {
				list: [],
				totalPage: 0,
				currentPage: 1,
				currentTab: this.$route.query.type || 'loginLogs',
			},
			search: {
				options: [],
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true,
			},
			eventShow: false,
			currentRightPanel: null,
			rightPanelData: null,
			teamList: [],
		}
	},
	computed: {
		// attribute text
		attrText() {
			return this.getAttrText()
		},
	},
	created() {
		let params = this.$route.query.type
		this.changeCurrentTab(1, params)
		this.getTeamList()
	},
	methods: {
		// init attribute text
		getAttrText() {
			return {
				loginLog: this.$gettext('Login Log'),
				teamLog: this.$gettext('Team Log'),
				clusterLog: this.$gettext('Cluster Log'),
				workgroupLog: this.$gettext('Workgroup Logs'),
				alarmLog: this.$gettext('Alarm Log'),
				userType: this.$gettext('Account Type'),
				eventType: this.$gettext('Event Type'),
				event: this.$gettext('Event'),
				safeAdmin: this.$gettext('Safe Admin'),
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				select: this.$gettext('Select'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				inputAccount: this.$gettext('Please input account'),
				input: this.$gettext('Please input'),
				time: this.$gettext('Time'),
				account: this.$gettext('Account'),
				accountType: this.$gettext('Account Type'),
				loginIp: this.$gettext('Login Ip'),
				clusterName: this.$gettext('Cluster Name'),
				resourceName: this.$gettext('Resource Name'),
				teamName: this.$gettext('Team Name'),
				accountEdited: this.$gettext('Account Edited'),
				workgroupName: this.$gettext('Workgroup Name'),
				groupEdited: this.$gettext('Group Edited'),
				ruleId: this.$gettext('Rule Id'),
				eventType: this.$gettext('Event Type'),
				createTime: this.$gettext('Create Time'),
				action: this.$gettext('Action'),
				loginStatus: this.$gettext('Login Status'),
				comment: this.$gettext('Comment'),
				operationTime: this.$gettext('Operation Time'),
				sourceIp: this.$gettext('Source IP'),
				operationObj: this.$gettext('Operation Obj'),
				workGroup: this.$gettext('In Work Group'),
				connectType: this.$gettext('Connect Type'),
				eventDesc: this.$gettext('Event Desc'),
				norifyObj: this.$gettext('Notify Obj'),
				users: this.$gettext('Users'),
			}
		},
		// 获取登录日志
		getLoginLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})
			this.$store.dispatch(STORE_CONST.LOG.LOGIN, { params: params }).then(
				(res) => {
					if (res && res.objects.length) {
						this.selectOptions = {}
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
				},
				() => {
					this.loading = false
				}
			)
		},
		// 获取团队日志
		getTeamLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})
			this.$store.dispatch(STORE_CONST.LOG.TEAM, { params: params }).then(
				(res) => {
					if (res && res.objects.length) {
						this.selectOptions = SelectOptionsConfig.teamLogs
						this.log.list = this.$store.getters.logs.teamLogs.objects
						this.log.totalPage = this.$store.getters.logs.teamLogs.num_results
						setTimeout(() => {
							this.eventShow = true
						}, 10)
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
				},
				() => {
					this.loading = false
				}
			)
		},
		// 获取集群日志
		getClusterLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})
			this.$store.dispatch(STORE_CONST.LOG.CLUSTER, { params: params }).then(
				(res) => {
					if (res && res.objects.length) {
						this.selectOptions = SelectOptionsConfig.clusterLogs
						this.log.list = this.$store.getters.logs.clusterLogs.objects
						this.log.totalPage = this.$store.getters.logs.clusterLogs.num_results
						setTimeout(() => {
							this.eventShow = true
						}, 10)
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
				},
				() => {
					this.loading = false
				}
			)
		},
		// 获取资源日志
		getResourceLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})
			this.$store.dispatch(STORE_CONST.LOG.RESOURCE, { params: params }).then(
				(res) => {
					if (res && res.objects.length) {
						this.selectOptions = SelectOptionsConfig.resourceLogs
						this.log.list = this.$store.getters.logs.resourceLogs.objects
						this.log.totalPage = this.$store.getters.logs.resourceLogs.num_results
						setTimeout(() => {
							this.eventShow = true
						}, 10)
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
				},
				() => {
					this.loading = false
				}
			)
		},
		// 获取告警日志
		getAlarmLog(page) {
			this.loading = true
			let params = {
				page_index: page || 1,
			}
			this.search.options.forEach((item) => {
				params[item.key] = item.val
			})
			this.$store.dispatch(STORE_CONST.LOG.ALARM, { params: params }).then(
				(res) => {
					console.log(res, '告警日志')
					if (res && res.objects.length) {
						this.selectOptions = SelectOptionsConfig.alarmLogs
						this.log.list = this.$store.getters.logs.alarmLogs.objects
						this.log.totalPage = this.$store.getters.logs.alarmLogs.num_results
						setTimeout(() => {
							this.eventShow = true
						}, 10)
					} else {
						this.log.list = res.objects
						this.log.totalPage = res.num_results
					}
					this.loading = false
					console.log(SelectOptionsConfig.alarmLogs, 'SelectOptionsConfig.alarmLogs')
				},
				() => {
					this.loading = false
				}
			)
		},
		// 新建事件通知
		toShowAlarmDetail(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'alarmLogDetail' ? 0 : 300
			this.currentRightPanel = alarmLogDetail
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row
				}, time)
			})
		},
		// 获取团队成员
		getTeamList() {
			this.$store.dispatch(STORE_CONST.TEAM.GET_MEMBER_LIST).then((res) => {
				console.log(res, 'res')
				if (res && res.objects && res.objects.length) {
					this.teamList = res.objects
				}
			})
		},
		// tab栏切换
		onTabClick(v) {
			this.$router.push({ name: 'log', query: { type: v.name } })
			this.log.currentTab = this.$route.query.type || 'loginLogs'
			this.log.currentPage = 1
			this.search.options = []
			this.eventShow = false
			this.resetSearchValue()
		},
		// search event
		onSearch() {
			this.log.currentPage = 1
			this.search.options = []
			if (this.search.startTime !== '') {
				this.search.options.push({
					key: 'start_time',
					val: this.search.startTime.getTime() / 1000,
				})
			}
			if (this.search.endTime !== '') {
				this.search.options.push({
					key: 'end_time',
					val: this.search.endTime.getTime() / 1000 + 24 * 3600,
				})
			}
			if (this.search.isAdmin !== '') {
				this.search.options.push({
					key: 'admin',
					val: this.search.isAdmin,
				})
			}
			if (this.search.account !== '') {
				if (this.search.role === '') {
					this.search.options.push({
						key: 'account',
						val: this.search.account,
					})
				} else {
					this.search.options.push({
						key: this.search.role,
						val: this.search.account,
					})
				}
			}
			if (this.search.eventType !== '') {
				this.search.options.push({
					key: 'event',
					val: this.search.eventType,
				})
			}
			this.changeCurrentTab(1, this.log.currentTab)
		},
		// change page event
		onChangePage(page) {
			this.changeCurrentTab(page, this.log.currentTab)
		},
		// watch search role's value
		onSelectRole() {
			if (this.search.role !== '') {
				this.search.isDisabled = false
			}
		},
		// tab切换加载不同的数据
		changeCurrentTab(page, tab) {
			this.log.currentTab = tab
			if (tab === 'loginLogs') {
				this.getLoginLog(page)
			} else if (tab === 'teamLogs') {
				this.getTeamLog(page)
			} else if (tab === 'clusterLogs') {
				this.getClusterLog(page)
			} else if (tab === 'resourceLogs') {
				this.getResourceLog(page)
			} else if (tab === 'alarmLogs') {
				this.getAlarmLog(page)
			}
		},
		// reset search params
		resetSearchValue() {
			this.search = Object.assign({}, this.search, {
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true,
			})
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},

		// 导出日志
		exportLog() {
			if (this.search.role === '') {
				window.open(`${baseUrl.apiUrl}/event/sys_log_export?log_type=${this.log.currentTab}&admin=${this.search.isAdmin}&start_time=${this.search.startTime ? this.search.startTime.getTime() / 1000 : ''}&end_time=${this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : ''}&event=${this.search.eventType}&account=${this.search.account}`, '_blank')
			} else {
				window.open(`${baseUrl.apiUrl}/event/sys_log_export?log_type=${this.log.currentTab}&admin=${this.search.isAdmin}&start_time=${this.search.startTime ? this.search.startTime.getTime() / 1000 : ''}&end_time=${this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : ''}&event=${this.search.eventType}&${this.search.role}=${this.search.account}`, '_blank')
			}
		},
	},
	watch: {
		$route(to, from) {
			this.log.currentTab = this.$route.query.type
			this.changeCurrentTab(1, this.log.currentTab)
		},
	},
	components: {
		alarmLogDetail,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.system-dairy {
	.el-table__body-wrapper {
		overflow: hidden;
	}
	.add-ssk {
		padding: 0 15px;
		height: 60px;
		line-height: 60px;
		background-color: #fff;
		border: 1px solid $border-color;
		border-bottom: none;
		.pull-right {
			.event-search {
				width: 180px;
			}
			.account-search {
				width: 110px;
				.el-input__icon {
					font-size: 10px;
					width: 21px;
				}
				.el-input__inner {
					padding-right: 21px;
				}
				.el-button {
					padding: 8px 15px;
				}
			}
			.searchInput {
				width: 130px;
			}
			.date-picker {
				width: 130px;
			}
		}
	}
}
.ellipsis-mult {
	width: 100px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// system-log.vue?6e94ba3e